import { Pagination, Card, CardContent, CardMedia } from '@mui/material';
import './styles.css';
import MusicLoader from '../../common/Loading/musicLoader.gif';

const SingleNotesPaginatedCard = (props) => {
  const {isTinyMobileScreen, isSmallScreen, imgUrl, imgTitle, paginationLengthTotal, paginationIndex, isLoading} = props;

  return (
    <Card raised sx={{ minWidth: '100%',  borderRadius:'15px', marginTop: '20px' }}>
      <CardMedia
        sx={{ 
          minHeight: isTinyMobileScreen ? 250 : isSmallScreen ? 330 : 450, 
          marginRight: isLoading ? '' : '10px', 
          backgroundColor: isLoading ? 'black' : ''
        }}
        image={isLoading ? MusicLoader : imgUrl}
        title={imgTitle}
      />
      <CardContent className="notationCardContent" >
        <Pagination size="small" count={paginationLengthTotal} page={paginationIndex} variant='outlined' color="secondary" hidePrevButton hideNextButton/>
      </CardContent>
  </Card>

  )
}

export default SingleNotesPaginatedCard;